import React from 'react';
import { Clock, Calendar, Battery, Coffee } from 'lucide-react';
import { corporateProblems } from '../utils/mockData';

const problemIcons = [Clock, Calendar, Battery, Coffee];

export const ProblemSection = () => {
  return (
    <section className="py-20 bg-[#EBEBD3]/30">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-[#59642C] mb-6">
              Workdays are demanding.
              <br />
              <span className="text-[#961B1F]">Food shouldn't make them harder.</span>
            </h2>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto">
              Corporate professionals deserve food that tastes good and keeps them energized.
            </p>
          </div>

          {/* Problem Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {corporateProblems.map((problem, index) => {
              const Icon = problemIcons[index];
              return (
                <div
                  key={index}
                  className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1 border border-[#EBEBD3]"
                >
                  <div className="w-14 h-14 bg-[#FE9E1C]/10 rounded-xl flex items-center justify-center mb-4">
                    <Icon className="w-7 h-7 text-[#FE9E1C]" />
                  </div>
                  <p className="text-gray-800 font-medium leading-relaxed">{problem}</p>
                </div>
              );
            })}
          </div>

          {/* Bottom Statement */}
          <div className="mt-16 text-center">
            <div className="inline-block bg-white px-10 py-6 rounded-2xl shadow-sm border border-[#FE9E1C]/20">
              <p className="text-2xl font-semibold text-[#59642C]">
                That's where <span className="text-[#FE9E1C]">Balanced Bites Cafe</span> comes in
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
